<ion-list-header class="list-header">
  <pos-list-grid>
    <ng-content></ng-content>
  </pos-list-grid>
</ion-list-header>
